import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { getPortfolioSummary } from "../../api";
import styles from './Portfolio.module.css'
import { bigDecimal } from 'js-big-decimal';

function PortfolioSummary({custId}) {
  const [profitnlost, setProfitnLoss] = useState("--");
  const [currentVal, setCurrentVal] = useState("--");
  const [totalInvested, setTotalInvested] = useState("--");
  const [cashBalance, setCashBalance] = useState("--");

  const addCommasInPrice = (price, decimal = true) => {
    if (typeof price === 'string') {
      const cleanedPrice = price.replace(/[^0-9.-]/g, '');  
      if (!isNaN(cleanedPrice)) {
        return parseFloat(cleanedPrice).toLocaleString('en-US', { maximumFractionDigits: decimal ? 2 : 0 });
      }
    } else if (!isNaN(price)) {
      return parseFloat(price).toLocaleString('en-US', { maximumFractionDigits: decimal ? 2 : 0 });
    }
    return price;
  };

  const getDetails = async (custId) => {
    try {
      const resp = await getPortfolioSummary(custId);

      const totalCurrentValue = new bigDecimal(resp.portfolioSummary.totalCurrentValue ?? 0);
      const totalInvestmentAmount = new bigDecimal(resp.portfolioSummary.totalInvestmentAmount ?? 0);
      const profitLossValue = totalCurrentValue.subtract(totalInvestmentAmount);

      const roundedCurrentValue = totalCurrentValue.round(2);
      const roundedInvestedValue = totalInvestmentAmount.round(2);
      const roundedProfitLoss = profitLossValue.round(2);

   setCurrentVal(addCommasInPrice(roundedCurrentValue.getValue()));
        setTotalInvested(addCommasInPrice(roundedInvestedValue.getValue()));
        setCashBalance(resp.accountSummary.cashBalance !== null 
          ? addCommasInPrice(new bigDecimal(resp.accountSummary.cashBalance).round(2).getValue()) 
          : "--"
        );
        // setProfitnLoss((profitLossValue.isNegative() ? "-" : "") + addCommasInPrice(roundedProfitLoss.getValue()));

        setProfitnLoss(addCommasInPrice(roundedProfitLoss.getValue()));
      } catch (e) {
        console.error("Error fetching portfolio summary:", e);
        setProfitnLoss("--");
        setCurrentVal("--");
        setTotalInvested("--");
        setCashBalance("--");
      }
    };
  


  useEffect(() => {
    getDetails(custId);
  },[])

  return (
    <Row>
      <Col style={{margin: "0px 10px"}}>
        <div className={styles.stockValue}>$ {profitnlost}</div>
        <div className={styles.stockTitle}>Profit & Loss</div>
      </Col>
      <Col>
        <div className={styles.stockValue}>$ {currentVal}</div>
        <div className={styles.stockTitle}>Current value</div>
      </Col>
      <Col>
        <div className={styles.stockValue}>$ {totalInvested}</div>
        <div className={styles.stockTitle}>Total invested</div>
      </Col>
      <Col>
        <div className={styles.stockValue}>$ {cashBalance}</div>
        <div className={styles.stockTitle}>Cash balance</div>
      </Col>
    </Row>
  );
}

export default PortfolioSummary;
